import React from "react";
import LegalPage from "../../components/legal-page";

// Pravni tekst je namjerno samo na hrvatskom — mjerodavna je hrvatska verzija.
const Privacy = () => {
  return (
    <LegalPage
      title="Politika privatnosti"
      updated="Zadnja izmjena: 18. lipnja 2026."
    >
      <h2>1. Tko smo i tko je voditelj obrade</h2>
      <p>
        nemastruje.com je usluga koja korisnike obavještava o planiranim
        prekidima opskrbe <strong>električnom energijom i vodom</strong> u
        Hrvatskoj, na temelju javno objavljenih podataka HEP ODS-a te javnih
        vodoopskrbnih (komunalnih) poduzeća.
      </p>
      <p>
        Voditelj obrade osobnih podataka je <strong>Sensorium d.o.o.</strong>,
        Ulica Andrije Kačića Miošića 41, 10410 Velika Gorica, Hrvatska, OIB:{" "}
        <strong>89225725472</strong>. Za sva pitanja o privatnosti i ostvarivanje
        svojih prava obratite nam se na{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>.
      </p>
      <p>
        Nismo obvezni imenovati službenika za zaštitu podataka (DPO); za sva
        pitanja koristite gornji kontakt.
      </p>

      <h2>2. Koje podatke prikupljamo</h2>
      <ul>
        <li>ime (ako ga unesete) i e-mail adresu,</li>
        <li>broj mobitela — ako želite SMS obavijesti (Premium / Business),</li>
        <li>
          adresu ili adrese za koje želite primati obavijesti te njihove
          geografske koordinate,
        </li>
        <li>
          podatke o prijavi — ako se prijavljujete Google računom, od Googlea
          dobivamo vašu e-mail adresu i Google identifikator,
        </li>
        <li>
          podatke o pretplati i plaćanju (iznos, status, odabrani plan, broj
          računa). Podatke o platnoj kartici unosite izravno kod pružatelja
          platnih usluga (Revolut) — mi ih ne primamo niti pohranjujemo,
        </li>
        <li>
          tehničke podatke nužne za rad i sigurnost usluge — IP adresu,
          identifikator sesije i zapis u revizijskom dnevniku (audit log).
        </li>
      </ul>
      <p>
        Posebne kategorije podataka (čl. 9. GDPR-a, npr. podatke o zdravlju) ne
        prikupljamo niti je usluga za to namijenjena.
      </p>

      <h2>3. Svrhe i pravne osnove obrade</h2>
      <ul>
        <li>
          <strong>Pružanje usluge i upravljanje računom</strong> — izvršenje
          ugovora (čl. 6. st. 1. t. b GDPR-a).
        </li>
        <li>
          <strong>Slanje obavijesti o prekidima e-poštom i SMS-om</strong> za
          adrese koje ste unijeli — izvršenje ugovora (čl. 6. st. 1. t. b).
        </li>
        <li>
          <strong>Naplata pretplate i izdavanje računa</strong> — izvršenje
          ugovora te zakonska obveza (čl. 6. st. 1. t. b i c).
        </li>
        <li>
          <strong>Prijava putem Google računa</strong> (opcionalno) — privola
          (čl. 6. st. 1. t. a), koju možete povući u svakom trenutku.
        </li>
        <li>
          <strong>Sigurnost sustava i revizijski dnevnik</strong> — legitimni
          interes zaštite usluge i korisnika (čl. 6. st. 1. t. f).
        </li>
      </ul>
      <p>
        Davanje podataka nužno je za korištenje usluge; bez njih vam ne možemo
        slati obavijesti. Vaše podatke <strong>ne prodajemo</strong> niti ih
        koristimo za oglašavanje.
      </p>

      <h2>4. Kako koristimo vašu adresu</h2>
      <p>
        Adresa koju unesete koristi se isključivo za podudaranje s objavama o
        prekidima. Geokodiranje adrese (pretvaranje u koordinate) obavlja se na
        našoj vlastitoj infrastrukturi — adresa se u tu svrhu ne šalje trećim
        stranama.
      </p>

      <h2>5. Tko još obrađuje podatke (izvršitelji obrade)</h2>
      <p>
        Za pružanje usluge koristimo ograničen broj pružatelja koji podatke
        obrađuju u naše ime, na temelju ugovora o obradi podataka:
      </p>
      <ul>
        <li>
          <strong>Hetzner Online GmbH</strong> — poslužiteljska infrastruktura i
          geokodiranje; EU (Njemačka / Finska),
        </li>
        <li>
          <strong>Mailgun (Sinch)</strong> — slanje obavijesti i transakcijskih
          poruka e-poštom,
        </li>
        <li>
          <strong>Twilio</strong> — slanje SMS obavijesti i koda za potvrdu
          broja mobitela,
        </li>
        <li>
          <strong>Revolut</strong> — obrada plaćanja pretplate (hosted
          checkout); ne pohranjujemo podatke o kartici,
        </li>
        <li>
          <strong>Google</strong> — prijava putem Google računa (ako je
          odaberete).
        </li>
      </ul>
      <p>
        HEP ODS i javna vodoopskrbna društva <strong>nisu</strong> izvršitelji
        obrade — njihove objave o prekidima samo čitamo iz javno dostupnih
        izvora; vaše osobne podatke im ne dostavljamo.
      </p>

      <h2>6. Prijenos podataka izvan EU-a</h2>
      <p>
        Naši poslužitelji i pohrana nalaze se u EU. Pojedini pružatelji
        (primjerice Twilio i Google) mogu podatke obrađivati izvan Europskoga
        gospodarskog prostora; u tim se slučajevima prijenos temelji na
        standardnim ugovornim klauzulama (SCC) koje je odobrila Europska
        komisija.
      </p>

      <h2>7. Koliko dugo čuvamo podatke</h2>
      <ul>
        <li>
          Podatke o računu i adresama čuvamo dok je račun aktivan; nakon brisanja
          računa brišu se ili anonimiziraju u roku od 30 dana.
        </li>
        <li>Revizijski dnevnik (audit log) čuva se do 1 godine.</li>
        <li>
          Podatke o sesiji uklanjamo po odjavi ili u kratkom roku; token prijave
          čuva se u vašem pregledniku do odjave.
        </li>
        <li>
          Račune i računovodstvene isprave čuvamo najmanje 11 godina, sukladno
          Zakonu o računovodstvu; ostale podatke o plaćanju do isteka zastarnih
          rokova (u pravilu do 5 godina).
        </li>
        <li>
          Sigurnosne kopije su enkriptirane i pohranjene u EU; kopije baze čuvaju
          se do približno 3 mjeseca, a kopije datoteka do približno 60 dana,
          nakon čega se ciklički brišu.
        </li>
      </ul>

      <h2>8. Sigurnost podataka</h2>
      <p>
        Primjenjujemo primjerene tehničke i organizacijske mjere, među ostalim:
      </p>
      <ul>
        <li>enkripciju podataka u prijenosu (TLS/HTTPS) i HSTS,</li>
        <li>enkriptirane sesije u bazi podataka,</li>
        <li>ograničen pristup ovlaštenog osoblja po načelu nužnog minimuma,</li>
        <li>
          ograničavanje učestalosti zahtjeva (zaštita prijave i slanja koda od
          zlouporabe),
        </li>
        <li>
          revizijski dnevnik te redovite enkriptirane sigurnosne kopije u EU.
        </li>
      </ul>

      <h2>9. Automatizirano odlučivanje</h2>
      <p>
        Ne provodimo automatizirano donošenje odluka ni izradu profila koji bi
        proizvodili pravne ili slično značajne učinke na vas. Podudaranje adrese
        s objavama o prekidima služi isključivo za slanje obavijesti.
      </p>

      <h2>10. Vaša prava</h2>
      <p>Sukladno GDPR-u imate pravo:</p>
      <ul>
        <li>na pristup svojim podacima (čl. 15.),</li>
        <li>na ispravak netočnih podataka (čl. 16.),</li>
        <li>na brisanje („pravo na zaborav”, čl. 17.),</li>
        <li>na prenosivost podataka (čl. 20.),</li>
        <li>na prigovor na obradu temeljenu na legitimnom interesu (čl. 21.),</li>
        <li>na ograničenje obrade (čl. 18.),</li>
        <li>na povlačenje privole u svakom trenutku (čl. 7. st. 3.).</li>
      </ul>
      <p>
        Zahtjeve uputite na{" "}
        <a href="mailto:info@nemastruje.com">info@nemastruje.com</a>; odgovaramo
        bez nepotrebnog odgađanja, najkasnije u roku od mjesec dana. Ako smatrate
        da vaše podatke obrađujemo protivno propisima, imate pravo podnijeti
        pritužbu Agenciji za zaštitu osobnih podataka (AZOP,{" "}
        <a href="https://azop.hr" target="_blank" rel="noreferrer">
          azop.hr
        </a>
        ).
      </p>

      <h2>11. Kolačići i praćenje</h2>
      <p>
        Ne koristimo kolačiće za oglašavanje niti alate za praćenje. Za rad
        prijave koristimo isključivo tehničku pohranu u pregledniku
        (localStorage) koja čuva vašu sesiju prijave.
      </p>

      <h2>12. Izmjene ove politike</h2>
      <p>
        Ako izmijenimo ovu politiku, novu verziju objavit ćemo na ovoj stranici s
        naznačenim datumom zadnje izmjene. O značajnim izmjenama možemo vas
        obavijestiti e-poštom ili obavijesti u aplikaciji.
      </p>
    </LegalPage>
  );
};

export default Privacy;
